import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/roi/unit', { params });
  },
  create(data) {
    return axios.post('/v1/roi/unit', data);
  },
  update(id, params) {
    return axios.put(`/v1/roi/unit/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/roi/unit/${id}`);
  }
};
